import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../../utils/withRouter';
import Loader from '../../../../utils/Loader'
// import { clearSessionStorage } from '../../../utils/constants'
import Header from '../../../../common_components/Header';
// import { emailValidator } from '../../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from '../../../../common_components/Footerwithdr';
import HeaderWithLogo from '../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../common_components/admin_module_drawer';
import { fill_action } from '../../../../actions/fillCombo_action'
// import ReceiptList from '../registration_receipt/ReceiptList';
import { Link } from "react-router-dom";
import { getAdminDashboardData_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action"
import { data } from 'jquery';
import { getAdminPaymentSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action"
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip"
class PaymentSummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            paymentSummaryListNational: [],
            paymentSummaryListIntNational: [],
            paymentSummaryUtilityNational: [],
            paymentSummaryUtilityIntNational: [],
            visitorCharges: []
        }
        this.nationalrecord = this.nationalrecord.bind(this)
        this.utilityintnationalrecord = this.utilityintnationalrecord.bind(this)
        this.utilitynationalrecord = this.utilitynationalrecord.bind(this)
        this.internationalrecord = this.internationalrecord.bind(this)
        this.getPaymentSummaryList = this.getPaymentSummaryList.bind(this)
        this.onCountClick = this.onCountClick.bind(this)
        this.toIndianFormat = this.toIndianFormat.bind(this)

    }

    toIndianFormat(num) {
        if (num == null || num === '') return num;
        return Number(num).toLocaleString('en-IN');
    }

    componentDidMount() {
        this.getPaymentSummaryList()
    }

    // Get suummary list
    getPaymentSummaryList() {
        this.setState({ isLoading: true })
        this.props.getAdminPaymentSummaryList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Admin Data ------->", data.data[0])
                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedArea = 0
                    var temptotalAppliedAmount = 0
                    var temptotalZeroPaidCount = 0
                    var temptotalZeroPaidArea = 0
                    var temptotalZeroPaidAmount = 0
                    var temptotalAdvancePaidCount = 0
                    var temptotalAdvancePaidArea = 0
                    var temptotalAdvancePaidAmount = 0
                    var temptotalHundredPaidCount = 0
                    var temptotalHundredPaidArea = 0
                    var temptotalHundredPaidAmount = 0

                    var obj = {}

                    // All totals count only these segments (avoids double-counting detail rows)
                    const salableTotalSegments = ['NATIONAL BARE', 'NATIONAL SHELL', 'INTERNATIONAL BARE', 'INTERNATIONAL SHELL', 'BARTER BOOTH']
                    for (var i = 0; i < data.data[0].length; i++) {
                        if (salableTotalSegments.includes((data.data[0][i].ChapterName || '').trim().toUpperCase())) {
                            temptotalSalable = temptotalSalable + data.data[0][i].SalebleArea
                            temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[0][i].AppliedExibitorCount
                            temptotalAppliedArea = temptotalAppliedArea + data.data[0][i].AppliedArea
                            temptotalAppliedAmount = temptotalAppliedAmount + data.data[0][i].AppliedAmount

                            temptotalZeroPaidCount = temptotalZeroPaidCount + data.data[0][i].ZeroPercentPaidCount
                            temptotalZeroPaidArea = temptotalZeroPaidArea + data.data[0][i].ZeroPercentPaid
                            temptotalZeroPaidAmount = temptotalZeroPaidAmount + data.data[0][i].ZeroPercentAmount

                            temptotalAdvancePaidCount = temptotalAdvancePaidCount + data.data[0][i].AdvancePaidCount
                            temptotalAdvancePaidArea = temptotalAdvancePaidArea + data.data[0][i].AdvancePaidArea
                            temptotalAdvancePaidAmount = temptotalAdvancePaidAmount + data.data[0][i].AdvancePaidAmount

                            temptotalHundredPaidCount = temptotalHundredPaidCount + data.data[0][i].HundredPercentPaidCount
                            temptotalHundredPaidArea = temptotalHundredPaidArea + data.data[0][i].HundredpercentFullPaidArea
                            temptotalHundredPaidAmount = temptotalHundredPaidAmount + data.data[0][i].HundredPercentFullPaidAmount
                        }
                    }

                    obj.SalebleArea = temptotalSalable
                    obj.AppliedExibitorCount = temptotalAppliedExhCount
                    obj.AppliedArea = temptotalAppliedArea
                    obj.AppliedAmount = temptotalAppliedAmount

                    obj.ZeroPercentPaidCount = temptotalZeroPaidCount
                    obj.ZeroPercentPaid = temptotalZeroPaidArea
                    obj.ZeroPercentAmount = temptotalZeroPaidAmount

                    obj.AdvancePaidCount = temptotalAdvancePaidCount
                    obj.AdvancePaidArea = temptotalAdvancePaidArea
                    obj.AdvancePaidAmount = temptotalAdvancePaidAmount

                    obj.HundredPercentPaidCount = temptotalHundredPaidCount
                    obj.HundredpercentFullPaidArea = temptotalHundredPaidArea
                    obj.HundredPercentFullPaidAmount = temptotalHundredPaidAmount

                    obj.ChapterName = 'TOTAL'
                    if (data.data[0].length > 0 && data.data[0][data.data[0].length - 1].ChapterName != 'TOTAL') {
                        data.data[0].push(obj)
                    }
                    const finalNationalArr = data.data[0].map((item, index) => {
                        // Repeated chapter -> rowspan 0
                        if (
                            index > 0 &&
                            data.data[0][index - 1].ChapterName === item.ChapterName
                        ) {
                            return {
                                ...item,
                                rowspan: 0
                            };
                        }

                        // First occurrence -> count consecutive rows
                        let rowspan = 1;
                        let i = index + 1;

                        while (
                            i < data.data[0].length &&
                            data.data[0][i].ChapterName === item.ChapterName
                        ) {
                            rowspan++;
                            i++;
                        }

                        return {
                            ...item,
                            rowspan
                        };
                    });
                    this.setState({
                        isLoading: false,
                        paymentSummaryListNational: finalNationalArr,
                    })
                    // INTERNATIONAL==================================================

                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedArea = 0
                    var temptotalAppliedAmount = 0
                    var temptotalZeroPaidCount = 0
                    var temptotalZeroPaidArea = 0
                    var temptotalZeroPaidAmount = 0
                    var temptotalAdvancePaidCount = 0
                    var temptotalAdvancePaidArea = 0
                    var temptotalAdvancePaidAmount = 0
                    var temptotalHundredPaidCount = 0
                    var temptotalHundredPaidArea = 0
                    var temptotalHundredPaidAmount = 0

                    var obj = {}

                    for (var i = 0; i < data.data[1].length; i++) {
                        if (salableTotalSegments.includes((data.data[1][i].ChapterName || '').trim().toUpperCase())) {
                            temptotalSalable = temptotalSalable + data.data[1][i].SalebleArea
                            temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[1][i].AppliedExibitorCount
                            temptotalAppliedArea = temptotalAppliedArea + data.data[1][i].AppliedArea
                            temptotalAppliedAmount = temptotalAppliedAmount + data.data[1][i].AppliedAmount

                            temptotalZeroPaidCount = temptotalZeroPaidCount + data.data[1][i].ZeroPercentPaidCount
                            temptotalZeroPaidArea = temptotalZeroPaidArea + data.data[1][i].ZeroPercentPaid
                            temptotalZeroPaidAmount = temptotalZeroPaidAmount + data.data[1][i].ZeroPercentAmount

                            temptotalAdvancePaidCount = temptotalAdvancePaidCount + data.data[1][i].AdvancePaidCount
                            temptotalAdvancePaidArea = temptotalAdvancePaidArea + data.data[1][i].AdvancePaidArea
                            temptotalAdvancePaidAmount = temptotalAdvancePaidAmount + data.data[1][i].AdvancePaidAmount

                            temptotalHundredPaidCount = temptotalHundredPaidCount + data.data[1][i].HundredPercentPaidCount
                            temptotalHundredPaidArea = temptotalHundredPaidArea + data.data[1][i].HundredpercentFullPaidArea
                            temptotalHundredPaidAmount = temptotalHundredPaidAmount + data.data[1][i].HundredPercentFullPaidAmount
                        }
                    }

                    obj.SalebleArea = temptotalSalable
                    obj.AppliedExibitorCount = temptotalAppliedExhCount
                    obj.AppliedArea = temptotalAppliedArea
                    obj.AppliedAmount = temptotalAppliedAmount

                    obj.ZeroPercentPaidCount = temptotalZeroPaidCount
                    obj.ZeroPercentPaid = temptotalZeroPaidArea
                    obj.ZeroPercentAmount = temptotalZeroPaidAmount

                    obj.AdvancePaidCount = temptotalAdvancePaidCount
                    obj.AdvancePaidArea = temptotalAdvancePaidArea
                    obj.AdvancePaidAmount = temptotalAdvancePaidAmount

                    obj.HundredPercentPaidCount = temptotalHundredPaidCount
                    obj.HundredpercentFullPaidArea = temptotalHundredPaidArea
                    obj.HundredPercentFullPaidAmount = temptotalHundredPaidAmount

                    obj.ChapterName = 'TOTAL'
                    if (data.data[1].length > 0 && data.data[1][data.data[1].length - 1].ChapterName != 'TOTAL') {
                        data.data[1].push(obj)
                    }
                    const finalIntNationalArr = data.data[1].map((item, index) => {
                        // Repeated chapter -> rowspan 0
                        if (
                            index > 0 &&
                            data.data[1][index - 1].ChapterName === item.ChapterName
                        ) {
                            return {
                                ...item,
                                rowspan: 0
                            };
                        }

                        // First occurrence -> count consecutive rows
                        let rowspan = 1;
                        let i = index + 1;

                        while (
                            i < data.data[1].length &&
                            data.data[1][i].ChapterName === item.ChapterName
                        ) {
                            rowspan++;
                            i++;
                        }

                        return {
                            ...item,
                            rowspan
                        };
                    });
                    this.setState({
                        isLoading: false,
                        paymentSummaryListIntNational: finalIntNationalArr,
                    })
                    // ==============================================nat utility=============================

                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedQty = 0
                    var temptotalAppliedAmount = 0

                    var temptotalPaidExhCount = 0
                    var temptotalPaidQty = 0
                    var temptotalPaidAmount = 0

                    var temptotalUnpaidExhCount = 0
                    var temptotalUnpaidQty = 0
                    var temptotalUnpaidAmount = 0

                    var obj = {}

                    for (var i = 0; i < data.data[2].length; i++) {
                        temptotalSalable = temptotalSalable + data.data[2][i].SalebleArea
                        temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[2][i].AppliedExibitor
                        temptotalAppliedQty = temptotalAppliedQty + data.data[2][i].AppliedQuantity
                        temptotalAppliedAmount = temptotalAppliedAmount + data.data[2][i].ApplliedAmount

                        temptotalPaidExhCount = temptotalPaidExhCount + data.data[2][i].PaidExibitor
                        temptotalPaidQty = temptotalPaidQty + data.data[2][i].PaidQuantity
                        temptotalPaidAmount = temptotalPaidAmount + data.data[2][i].PaidAmount

                        temptotalUnpaidExhCount = temptotalUnpaidExhCount + data.data[2][i].UnpaidExibitor
                        temptotalUnpaidQty = temptotalUnpaidQty + data.data[2][i].UnpaidQuantity
                        temptotalUnpaidAmount = temptotalUnpaidAmount + data.data[2][i].UnpaidAmount
                    }

                    obj.SalebleArea = temptotalSalable
                    obj.AppliedExibitor = temptotalAppliedExhCount
                    obj.AppliedQuantity = temptotalAppliedQty
                    obj.ApplliedAmount = temptotalAppliedAmount

                    obj.PaidExibitor = temptotalPaidExhCount
                    obj.PaidQuantity = temptotalPaidQty
                    obj.PaidAmount = temptotalPaidAmount

                    obj.UnpaidExibitor = temptotalUnpaidExhCount
                    obj.UnpaidQuantity = temptotalUnpaidQty
                    obj.UnpaidAmount = temptotalUnpaidAmount

                    obj.UtilityService = 'TOTAL'
                    if (data.data[2].length > 0 && data.data[2][data.data[2].length - 1].UtilityService != 'TOTAL') {
                        data.data[2].push(obj)
                    }
                    const finalUtilityNationalArr = data.data[2].map((item, index) => {
                        // Repeated chapter -> rowspan 0
                        if (
                            index > 0 &&
                            data.data[2][index - 1].UtilityService === item.UtilityService
                        ) {
                            return {
                                ...item,
                                rowspan: 0
                            };
                        }

                        // First occurrence -> count consecutive rows
                        let rowspan = 1;
                        let i = index + 1;

                        while (
                            i < data.data[2].length &&
                            data.data[2][i].UtilityService === item.UtilityService
                        ) {
                            rowspan++;
                            i++;
                        }

                        return {
                            ...item,
                            rowspan
                        };
                    });
                    this.setState({
                        isLoading: false,
                        paymentSummaryUtilityNational: finalUtilityNationalArr,
                    })

                    // ==============================================Intnat utility=============================

                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedQty = 0
                    var temptotalAppliedAmount = 0

                    var temptotalPaidExhCount = 0
                    var temptotalPaidQty = 0
                    var temptotalPaidAmount = 0

                    var temptotalUnpaidExhCount = 0
                    var temptotalUnpaidQty = 0
                    var temptotalUnpaidAmount = 0

                    var obj = {}

                    for (var i = 0; i < data.data[3].length; i++) {
                        temptotalSalable = temptotalSalable + data.data[3][i].SalebleArea
                        temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[3][i].AppliedExibitor
                        temptotalAppliedQty = temptotalAppliedQty + data.data[3][i].AppliedQuantity
                        temptotalAppliedAmount = temptotalAppliedAmount + data.data[3][i].ApplliedAmount

                        temptotalPaidExhCount = temptotalPaidExhCount + data.data[3][i].PaidExibitor
                        temptotalPaidQty = temptotalPaidQty + data.data[3][i].PaidQuantity
                        temptotalPaidAmount = temptotalPaidAmount + data.data[3][i].PaidAmount

                        temptotalUnpaidExhCount = temptotalUnpaidExhCount + data.data[3][i].UnpaidExibitor
                        temptotalUnpaidQty = temptotalUnpaidQty + data.data[3][i].UnpaidQuantity
                        temptotalUnpaidAmount = temptotalUnpaidAmount + data.data[3][i].UnpaidAmount
                    }

                    obj.SalebleArea = temptotalSalable
                    obj.AppliedExibitor = temptotalAppliedExhCount
                    obj.AppliedQuantity = temptotalAppliedQty
                    obj.ApplliedAmount = temptotalAppliedAmount

                    obj.PaidExibitor = temptotalPaidExhCount
                    obj.PaidQuantity = temptotalPaidQty
                    obj.PaidAmount = temptotalPaidAmount

                    obj.UnpaidExibitor = temptotalUnpaidExhCount
                    obj.UnpaidQuantity = temptotalUnpaidQty
                    obj.UnpaidAmount = temptotalUnpaidAmount

                    obj.UtilityService = 'TOTAL'
                    if (data.data[3].length > 0 && data.data[3][data.data[3].length - 1].UtilityService != 'TOTAL') {
                        data.data[3].push(obj)
                    }
                    const finalUtilityIntNationalArr = data.data[3].map((item, index) => {
                        // Repeated chapter -> rowspan 0
                        if (
                            index > 0 &&
                            data.data[3][index - 1].UtilityService === item.UtilityService
                        ) {
                            return {
                                ...item,
                                rowspan: 0
                            };
                        }

                        // First occurrence -> count consecutive rows
                        let rowspan = 1;
                        let i = index + 1;

                        while (
                            i < data.data[3].length &&
                            data.data[3][i].UtilityService === item.UtilityService
                        ) {
                            rowspan++;
                            i++;
                        }

                        return {
                            ...item,
                            rowspan
                        };
                    });
                    this.setState({
                        isLoading: false,
                        paymentSummaryUtilityIntNational: finalUtilityIntNationalArr,
                    })
                    // =============visitor===============
                    var totalApplied = 0
                    var totalAmount = 0
                    data.data[4].length > 0 && data.data[4].map(item => {
                        totalApplied = totalApplied + item.SingleDay + item.TwoDays + item.ThreeDays + item.FourDays + item.FiveDays + item.SixDays
                        totalAmount = totalAmount + item.SingleDayAmount + item.TwoDaysAmount + item.ThreeDaysAmount + item.FourDaysAmount + item.FiveDaysAmount + item.SixDaysAmount
                        item.totalApplied = totalApplied
                        item.totalAmount = totalAmount
                    })

                    this.setState({
                        isLoading: false,
                        visitorCharges: data.data[4],
                    })


                    // console.log(result);
                    console.log("Data ------->", finalNationalArr, this.state.paymentSummaryList)

                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onCountClick(chapterName, status) {
        console.log("Keyword------------>", `${chapterName.trim()}/${status}`)
        this.props.navigate('/exhibitorlist', {
            state: {
                fromDashBoard: true,
                paymentType: status == "EXHIBITORS_25%" ? 2 : status == "EXHIBITORS_100%" ? 3 : null,
                exhibitorType: chapterName.trim() == "INDIAN PARTICIPANTS" ? 1 : chapterName.trim() == "FOREIGN PARTICIPANTS" ? 2 :
                    chapterName.trim() == "TOTAL" ? "" : null
            }
        })
    }

    visitorCharges(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Service</th>
                        <th className="text-center">Applied Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Single Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Two Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Three Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Four Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Five Visitor</th>
                        <th className="text-center">Amount</th>
                        <th className="text-center">Six Visitor</th>
                        <th className="text-center">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td >{data.Service}</td>
                                    <td >{data.totalApplied}</td>
                                    <td >{this.toIndianFormat(data.totalAmount)}</td>

                                    <td >{data.SingleDay}</td>
                                    <td >{this.toIndianFormat(data.SingleDayAmount)}</td>

                                    <td >{data.TwoDays}</td>
                                    <td >{this.toIndianFormat(data.TwoDaysAmount)}</td>

                                    <td >{data.ThreeDays}</td>
                                    <td >{this.toIndianFormat(data.ThreeDaysAmount)}</td>

                                    <td >{data.FourDays}</td>
                                    <td >{this.toIndianFormat(data.FourDaysAmount)}</td>

                                    <td >{data.FiveDays}</td>
                                    <td >{this.toIndianFormat(data.FiveDaysAmount)}</td>

                                    <td >{data.SixDays}</td>
                                    <td >{this.toIndianFormat(data.SixDaysAmount)}</td>

                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    utilityintnationalrecord(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Utility Service</th>
                        <th className="text-center"></th>
                        <th className="text-center">Stall type</th>
                        <th className="text-center" colspan="3">Applied</th>
                        <th className="text-center" colspan="3">Paid</th>
                        <th className="text-center" colspan="3">UnPaid</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(USD)</th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(USD)</th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(USD)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.UtilityService}</strong>
                                        ) : data.UtilityService}
                                    </td>}
                                    <td className={"text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "SalebleArea")}
                                    >{i == list.length - 1 ? '' : 'International'}</td>
                                    <td className={data.StallTypeName < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.StallTypeName}</strong> : data.StallTypeName}</td>

                                    <td className={data.AppliedExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitor}</strong> : data.AppliedExibitor}</td>
                                    <td className={data.AppliedQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedQuantity}</strong> : data.AppliedQuantity}</td>
                                    <td className={data.ApplliedAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.ApplliedAmount)}</strong> : this.toIndianFormat(data.ApplliedAmount)}</td>

                                    <td className={data.PaidExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.PaidExibitor}</strong> : data.PaidExibitor}</td>
                                    <td className={data.PaidQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.PaidQuantity}</strong> : data.PaidQuantity}</td>
                                    <td className={data.PaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.PaidAmount)}</strong> : this.toIndianFormat(data.PaidAmount)}</td>

                                    <td className={data.UnpaidExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.UnpaidExibitor}</strong> : data.UnpaidExibitor}</td>
                                    <td className={data.UnpaidQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.UnpaidQuantity}</strong> : data.UnpaidQuantity}</td>
                                    <td className={data.UnpaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.UnpaidAmount)}</strong> : this.toIndianFormat(data.UnpaidAmount)}</td>
                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    utilitynationalrecord(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Utility Service</th>
                        <th className="text-center"></th>
                        <th className="text-center">Stall type</th>
                        <th className="text-center" colspan="3">Applied</th>
                        <th className="text-center" colspan="3">Paid</th>
                        <th className="text-center" colspan="3">UnPaid</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(INR)</th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(INR)</th>
                        <th className="text-center">Exhibitor</th>
                        <th className="text-center">Quantity(KW/Units/Nos)</th>
                        <th className="text-center">Amount(INR)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.UtilityService}</strong>
                                        ) : data.UtilityService}
                                    </td>}
                                    <td className={"text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "SalebleArea")}
                                    >{i == list.length - 1 ? '' : 'National'}</td>
                                    <td className={data.StallTypeName < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.StallTypeName}</strong> : data.StallTypeName}</td>

                                    <td className={data.AppliedExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitor}</strong> : data.AppliedExibitor}</td>
                                    <td className={data.AppliedQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedQuantity}</strong> : data.AppliedQuantity}</td>
                                    <td className={data.ApplliedAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.ApplliedAmount)}</strong> : this.toIndianFormat(data.ApplliedAmount)}</td>

                                    <td className={data.PaidExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.PaidExibitor}</strong> : data.PaidExibitor}</td>
                                    <td className={data.PaidQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.PaidQuantity}</strong> : data.PaidQuantity}</td>
                                    <td className={data.PaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.PaidAmount)}</strong> : this.toIndianFormat(data.PaidAmount)}</td>

                                    <td className={data.UnpaidExibitor < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.UnpaidExibitor}</strong> : data.UnpaidExibitor}</td>
                                    <td className={data.UnpaidQuantity < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.UnpaidQuantity}</strong> : data.UnpaidQuantity}</td>
                                    <td className={data.UnpaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.UnpaidAmount)}</strong> : this.toIndianFormat(data.UnpaidAmount)}</td>
                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    nationalrecord(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Segment</th>
                        <th className="text-center">Stall type</th>
                        <th className="text-center">Salable Area(sqm)</th>
                        <th className="text-center" colspan="3">Applied</th>
                        <th className="text-center" colspan="3">0% Paid</th>
                        <th className="text-center" colspan="3">Advance Paid</th>
                        <th className="text-center" colspan="3">100% Paid</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(INR)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(INR)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(INR)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(INR)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.ChapterName}</strong>
                                        ) : data.ChapterName}
                                    </td>}
                                    <td className={data.StallTypeName < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "SalebleArea")}
                                    >{i == list.length - 1 ? '' : data.StallTypeName}</td>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className={data.SalebleArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.SalebleArea}</strong> : data.SalebleArea}</td>}

                                    <td className={data.AppliedExibitorCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitorCount}</strong> : data.AppliedExibitorCount}</td>
                                    <td className={data.AppliedArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedArea}</strong> : data.AppliedArea}</td>
                                    <td className={data.AppliedAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.AppliedAmount)}</strong> : this.toIndianFormat(data.AppliedAmount)}</td>

                                    <td className={data.ZeroPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaidCount}</strong> : data.ZeroPercentPaidCount}</td>
                                    <td className={data.ZeroPercentPaid < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaid}</strong> : data.ZeroPercentPaid}</td>
                                    <td className={data.ZeroPercentAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.ZeroPercentAmount)}</strong> : this.toIndianFormat(data.ZeroPercentAmount)}</td>

                                    <td className={data.AdvancePaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AdvancePaidCount}</strong> : data.AdvancePaidCount}</td>
                                    <td className={data.AdvancePaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AdvancePaidArea}</strong> : data.AdvancePaidArea}</td>
                                    <td className={data.AdvancePaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.AdvancePaidAmount)}</strong> : this.toIndianFormat(data.AdvancePaidAmount)}</td>

                                    <td className={data.HundredPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.HundredPercentPaidCount}</strong> : data.HundredPercentPaidCount}</td>
                                    <td className={data.HundredpercentFullPaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.HundredpercentFullPaidArea}</strong> : data.HundredpercentFullPaidArea}</td>
                                    <td className={data.HundredPercentFullPaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.HundredPercentFullPaidAmount)}</strong> : this.toIndianFormat(data.HundredPercentFullPaidAmount)}</td>
                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    internationalrecord(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Segment</th>
                        <th className="text-center">Stall type</th>
                        <th className="text-center">Salable Area(sqm)</th>
                        <th className="text-center" colspan="3">Applied</th>
                        <th className="text-center" colspan="3">0% Paid</th>
                        <th className="text-center" colspan="3">Advance Paid</th>
                        <th className="text-center" colspan="3">100% Paid</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(USD)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(USD)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(USD)</th>
                        <th className="text-center">Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center">Amount(USD)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.ChapterName}</strong>
                                        ) : data.ChapterName}
                                    </td>}
                                    <td className={data.StallTypeName < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "SalebleArea")}
                                    >{i == list.length - 1 ? '' : data.StallTypeName}</td>
                                    {data.rowspan != 0 && <td rowSpan={data.rowspan} className={data.SalebleArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.SalebleArea}</strong> : data.SalebleArea}</td>}

                                    <td className={data.AppliedExibitorCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitorCount}</strong> : data.AppliedExibitorCount}</td>
                                    <td className={data.AppliedArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedArea}</strong> : data.AppliedArea}</td>
                                    <td className={data.AppliedAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.AppliedAmount)}</strong> : this.toIndianFormat(data.AppliedAmount)}</td>

                                    <td className={data.ZeroPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaidCount}</strong> : data.ZeroPercentPaidCount}</td>
                                    <td className={data.ZeroPercentPaid < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaid}</strong> : data.ZeroPercentPaid}</td>
                                    <td className={data.ZeroPercentAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.ZeroPercentAmount)}</strong> : this.toIndianFormat(data.ZeroPercentAmount)}</td>

                                    <td className={data.AdvancePaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AdvancePaidCount}</strong> : data.AdvancePaidCount}</td>
                                    <td className={data.AdvancePaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AdvancePaidArea}</strong> : data.AdvancePaidArea}</td>
                                    <td className={data.AdvancePaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.AdvancePaidAmount)}</strong> : this.toIndianFormat(data.AdvancePaidAmount)}</td>

                                    <td className={data.HundredPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.HundredPercentPaidCount}</strong> : data.HundredPercentPaidCount}</td>
                                    <td className={data.HundredpercentFullPaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.HundredpercentFullPaidArea}</strong> : data.HundredpercentFullPaidArea}</td>
                                    <td className={data.HundredPercentFullPaidAmount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{this.toIndianFormat(data.HundredPercentFullPaidAmount)}</strong> : this.toIndianFormat(data.HundredPercentFullPaidAmount)}</td>
                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    render() {
        const { isLoading, paymentSummaryListNational, paymentSummaryListIntNational } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />
                    {/*app-content open*/}
                    {/* <div className="app-content with-dr-container com-height"> */}
                    {/* <AdminDashboardTopmenu /> */}
                    <div className='admin-top-space'>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.nationalrecord(paymentSummaryListNational)}
                            </div>
                        </div>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.internationalrecord(paymentSummaryListIntNational)}
                            </div>
                        </div>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.utilitynationalrecord(this.state.paymentSummaryUtilityNational)}
                            </div>
                        </div>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.utilityintnationalrecord(this.state.paymentSummaryUtilityIntNational)}
                            </div>
                        </div>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.visitorCharges(this.state.visitorCharges)}
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </>
                {/* <Footerwithdr /> */}
            </>
        );
    }
}

export default withRouter(connect(null, { getAdminPaymentSummaryList_action, getAdminDashboardData_action })(PaymentSummary));
